<template>
    <div class="g cart-info-section">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        data: function(){
            
            return {}
        },
    }
</script>

<style scoped lang="scss">

    .g.cart-info-section {
        flex: 1;
        max-width: 842px;
        margin: 0 auto;

        ul {
            @extend %reset;
        }

        li {

            + li {
                margin-top: $interval-l;
                // border-top: $border;
            }
        }

        .md {

            + .md {
                margin-top: $interval-l;
            }
        }
    }
</style>
